export default __webpack_public_path__ + "static/media/placeholder_business06-en-mobile.82add780.png";